import React, { Component } from 'react'
import Axios from 'axios';
import cachios from 'cachios'
import Header from '../header/newheader'
import Footer from '../footer/newfooter'
import home from '../assets/Home/home.png'
import togglearrow from '../assets/Home/togglearrow.png'
import crumbarrow from '../assets/Home/right.png'
import TopBar from '../topbar/topbar'
import search from '../assets/search.png'
import { BASE } from '../api/api';
import { Link } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser'
import './clusters.css'
import { List } from 'react-content-loader';

import ReactPaginate from 'react-paginate';

// import 'bootstrap/dist/css/bootstrap.min.css';

import "./clusterGrants.css";

const url = 'http://ifdb-be.tridz.in/'

const completed_data = [
    { lead: ["Fintech, Digital Currency", " (Palgrave Macmillan)"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle" },
]
const publication_data = [
    { lead: ["Fintech, Digital Currency", " (Palgrave Macmillan)"], title: 'Alam, Nafis & Ali, Syed Nazim', grant: "Book Chapter", year: "2020" },
    { lead: ["Morocco Chapter on Shariah", "Governance in Islamic Finance"], title: 'Aassouli, Dalal', grant: "Book", year: "2020" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle", year: "2013" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle", year: "2013" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle", year: "2013" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle", year: "2013" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle", year: "2013" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle", year: "2013" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle", year: "2013" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle", year: "2013" },
]

const members_data = [
    { img: "/clusters/ifdbPerson.jpg", name: "Dr. Syed Nazim Ali", desg: "Director" },
    { img: "/clusters/ifdbPerson.jpg", name: "Saqid Hafiz Khateeb", desg: "IBIR-Project Lead" },
    { img: "/clusters/ifdbPerson.jpg", name: "Umar Farooq patel", desg: "Research Fellow" },
    { img: "/clusters/ifdbPerson.jpg", name: "Bahnaz Ali Al-Quradaghi", desg: "Researcher" },
    { img: "/clusters/ifdbPerson.jpg", name: "Zul hakim bin Jumat", desg: "Researcher" },
]

const cycle_data = [
    { title: "Islamic Sukuk", lead: "Dr. Abdelrahman", grant: "QAR 20,000" },
    { title: "Hinduism in Muslim Theology", lead: "Dr. Dheen Muhamed", grant: "QAR 20,000" },
    { title: "Islamic Sukuk", lead: "Dr. Abdelrahman", grant: "QAR 20,000" }
]
const cycle_data1 = [
    { title: "Hinduism in Muslim Theology", lead: "Dr. Dheen Muhamed", grant: "QAR 20,000" },
    { title: "Islamic Sukuk", lead: "Dr. Abdelrahman", grant: "QAR 20,000" },
    { title: "Islamic Sukuk", lead: "Dr. Abdelrahman", grant: "QAR 20,000" }
]

class ClustersGrants extends Component {

    constructor(props) {
        super(props);
        this.state = {
            size: 10,
            tab: props.match.params.stage ? Number(props.match.params.stage) : 1,
            cycle1: [],
            cycle2: [],
            cycle3: [],
            cycle4: [],
            cycle1Include: [],
            cycle2Include: [],
            cycle3Include: [],
            cycle4Include: [],

        }
    }
    componentDidMount() {
        if (this)
            Axios.get(`${BASE}jsonapi/node/project?include=field_grant_authoritys,field_lead_project__investigator&filter[field_lead_cycles]=Cycle 1`)
                .then(data => {
                    console.log("cycle1", data.data.data)
                    this.setState({
                        cycle1: data.data.data,
                        cycle1Include: data.data.included
                    })
                })
        Axios.get(`${BASE}jsonapi/node/project?include=field_grant_authoritys,field_lead_project__investigator&filter[field_lead_cycles]=Cycle 2`)
            .then(data => {
                console.log("cycle2", data.data.data)
                this.setState({
                    cycle2: data.data.data,
                    cycle2Include: data.data.included
                })
            })
        Axios.get(`${BASE}jsonapi/node/project?include=field_grant_authoritys,field_lead_project__investigator&filter[field_lead_cycles]=Cycle 3`)
            .then(data => {
                console.log("cycle3", data.data.data)
                this.setState({
                    cycle3: data.data.data,
                    cycle3Include: data.data.included
                })
            })
        Axios.get(`${BASE}jsonapi/node/project?include=field_grant_authoritys,field_lead_project__investigator&filter[field_lead_cycles]=Cycle 4`)
            .then(data => {
                console.log("cycle4", data.data.data)
                this.setState({
                    cycle4: data.data.data,
                    cycle4Include: data.data.included
                })
            })
    }
    componentDidUpdate(prevProps, prevState) {
        console.log("prevState", prevState)
        if (prevState.tab !== this.state.tab) {
            if (this.state.tab === 1) {
                this.props.history.push("/cluster_grants/1")
            }
            else if (this.state.tab === 2) {
                this.props.history.push("/cluster_grants/2")
            }
            else if (this.state.tab === 3) {
                this.props.history.push("/cluster_grants/3")
            }
            else if (this.state.tab === 4) {
                this.props.history.push("/cluster_grants/4")
            }
        }
    }
    render() {
        return (
            <div>
                <Header />
                <div className='title-banner'>
                    <div className='container'>
                        <div className="heading-one text-center bold white-text">
                            Research Clusters Grants
                        </div>
                    </div>
                </div>
                <div className='container'>
                    <div className='subHeader'>
                        <div className='top-contents'>
                            <div className="new-crumbs breadcrumbs gray-text"><Link to='/' className='gray-text'><img className='crumb-home' src={home} /></Link><img className='rightarrow' src={crumbarrow} />Research<img className='rightarrow' src={crumbarrow} /><Link to='/cluster_grants' className='gray-text'>Research Clusters Grants</Link></div>
                            {/* <TopBar data={'data4'} /> */}
                        </div>
                    </div>
                    <p className='body-two gray-text text-justify'>
                        To enhance the research capacity, the CIS through research division has initiated research clusters grant. As the name suggests, the clusters grant is aimed at encouraging and supporting faculty members to undertake research projects, which not only enhances the research outcome and profile of CIS but at the same time, also helps in developing and advancing the research interests of the faculty. Not only that, a strong pre-condition for the award of these grants is the use of student research assistants. The project leads are encouraged to use student research assistants to help groom and develop their research capabilities and, in the process, building better researchers.
                    </p>
                    <p className='body-two gray-text text-justify'>
                        Since its inception in 2018, the research clusters grant is awarded each year for projects with defined outcomes. The proposed projects should lead to publications in the form of either a book with a reputed international publisher or publications of articles in Scopus indexed open access journals or hosting a conference / seminar / workshop or even to develop the research ideas into worthy project proposals eligible for bigger national and international grants, thus enhancing the CIS profile.

                    </p>


                    <div className='projectall_container'>
                        <div className='projectsToggle clusterGrant-toggle'>
                            <div className='toggle-head heading-three bold blue-text'>Grant Cycle</div>
                            <div className="toggle-bar-one">
                                <button onClick={() => this.setState({ tab: 4 })} className={this.state.tab === 4 ? 'blue-text body-two' : "gray-text body-two"}>Cycle 4 {this.state.tab === 4 ? <img className='toggle-arrow' src={togglearrow} /> : ""}</button>
                                <button onClick={() => this.setState({ tab: 3 })} className={this.state.tab === 3 ? 'blue-text body-two' : "gray-text body-two"}>Cycle 3 {this.state.tab === 3 ? <img className='toggle-arrow' src={togglearrow} /> : ""}</button>
                                <button onClick={() => this.setState({ tab: 2 })} className={this.state.tab === 2 ? 'blue-text body-two' : "gray-text body-two"}>Cycle 2 {this.state.tab === 2 ? <img className='toggle-arrow' src={togglearrow} /> : ""}</button>
                                <button onClick={() => this.setState({ tab: 1 })} className={this.state.tab === 1 ? 'blue-text body-two' : "gray-text body-two"}>Cycle 1 {this.state.tab === 1 ? <img className='toggle-arrow' src={togglearrow} /> : ""}</button>
                            </div>
                        </div>
                        <div className='clusterGrants_table'>

                            {this.state.cycle1.length || this.state.cycle2.length || this.state.cycle3.length || this.state.cycle4.length ? <table className='newTable'>
                                {
                                    <tr className='clusterGrants-head'>
                                        <th className='tableHead_1'><p>Project Title</p></th>
                                        <th className='tableHead_2'><p>Project Lead</p></th>
                                        <th className='tableHead_3 min-wids'><p>Grant Amount</p></th>
                                    </tr>

                                }

                                <tbody className='grants_table'>

                                    {
                                        this.state.tab === 4 ?
                                            this.state.cycle4.length ? this.state.cycle4.map((item) => {
                                                let lead
                                                if (item.relationships.field_lead_project__investigator.data) {
                                                    lead = this.state.cycle4Include.filter(x => x.id === item.relationships.field_lead_project__investigator.data.id)
                                                }
                                                return (
                                                    <tr className='projectDetails-row'>
                                                        <td className='grantsCycle_title'><Link to={`/projectdetails/${item.attributes.drupal_internal__nid}`} >{item.attributes.title ? item.attributes.title : ""}</Link></td>
                                                        <td className='grantsCycle_lead'> {item.relationships.field_lead_project__investigator.data ? lead.length ? lead[0].attributes ? <Link to={`/content/${lead[0].attributes.title}/author_nodes/${lead[0].attributes.drupal_internal__nid}`}>{lead ? lead[0].attributes.title : ""}</Link> : "" : '' : ""}</td>
                                                        {item.attributes.field_grand__amount ? <td className='grantsCycle_grant min-wids'>QAR {item.attributes.field_grand__amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td> : ""}
                                                    </tr>
                                                )
                                            }) : "" :
                                            this.state.tab === 3 ?
                                                this.state.cycle3.length ? this.state.cycle3.map((item) => {
                                                    let lead
                                                    if (item.relationships.field_lead_project__investigator.data) {
                                                        lead = this.state.cycle3Include.filter(x => x.id === item.relationships.field_lead_project__investigator.data.id)
                                                    }
                                                    return (
                                                        <tr className='projectDetails-row'>
                                                            <td className='grantsCycle_title'><Link to={`/projectdetails/${item.attributes.drupal_internal__nid}`} >{item.attributes.title ? item.attributes.title : ""}</Link></td>
                                                            <td className='grantsCycle_lead'>{item.relationships.field_lead_project__investigator.data ? lead.length ? lead[0].attributes ? <Link to={`/content/${lead[0].attributes.title}/author_nodes/${lead[0].attributes.drupal_internal__nid}`}>{lead ? lead[0].attributes.title : ""}</Link> : "" : '' : ""}</td>
                                                            {item.attributes.field_grand__amount ? <td className='grantsCycle_grant min-wids'>QAR {item.attributes.field_grand__amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td> : ""}
                                                        </tr>
                                                    )
                                                }) : "" :
                                                this.state.tab === 2 ?
                                                    this.state.cycle2.length ? this.state.cycle2.map((item) => {
                                                        let lead
                                                        if (item.relationships.field_lead_project__investigator.data) {
                                                            lead = this.state.cycle2Include.filter(x => x.id === item.relationships.field_lead_project__investigator.data.id)
                                                        }
                                                        return (
                                                            <tr className='projectDetails-row'>
                                                                <td className='grantsCycle_title'><Link to={`/projectdetails/${item.attributes.drupal_internal__nid}`} >{item.attributes.title ? item.attributes.title : ""}</Link></td>
                                                                <td className='grantsCycle_lead'>{item.relationships.field_lead_project__investigator.data ? lead.length ? lead[0].attributes ? <Link to={`/content/${lead[0].attributes.title}/author_nodes/${lead[0].attributes.drupal_internal__nid}`}>{lead ? lead[0].attributes.title : ""}</Link> : "" : '' : ""}</td>
                                                                {item.attributes.field_grand__amount ? <td className='grantsCycle_grant min-wids'>QAR {item.attributes.field_grand__amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td> : ""}
                                                            </tr>
                                                        )
                                                    }) : "" :
                                                    this.state.tab === 1 ?
                                                        this.state.cycle1.length ? this.state.cycle1.map((item) => {
                                                            let lead
                                                            if (item.relationships.field_lead_project__investigator.data) {
                                                                lead = this.state.cycle1Include.filter(x => x.id === item.relationships.field_lead_project__investigator.data.id)
                                                            }
                                                            return (
                                                                <tr className='projectDetails-row'>
                                                                    <td className='grantsCycle_title'><Link to={`/projectdetails/${item.attributes.drupal_internal__nid}`} >{item.attributes.title ? item.attributes.title : ""}</Link></td>
                                                                    <td className='grantsCycle_lead'>{item.relationships.field_lead_project__investigator.data ? lead.length ? lead[0].attributes ? <Link to={`/content/${lead[0].attributes.title}/author_nodes/${lead[0].attributes.drupal_internal__nid}`}>{lead ? lead[0].attributes.title : ""}</Link> : "" : '' : ""}</td>
                                                                    {item.attributes.field_grand__amount ? <td className='grantsCycle_grant min-wids'>QAR {item.attributes.field_grand__amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td> : ""}
                                                                </tr>
                                                            )
                                                        }) : "" : ""

                                    }
                                </tbody>
                            </table>
                                : <List />}

                        </div>
                    </div>




                </div>
                <Footer />
            </div >
        )
    }
}
export default ClustersGrants;